import React from 'react';
import styled from 'styled-components';
import ResumenDeVentasPorMes from '../../components/vendors/ResumenDeVentasPorMes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0.5rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  
  .title {
    font-weight: 600;
    color: #495057;
    font-size: 1.1rem;
  }
  
  .back-button {
    background: none;
    border: none;
    color: #0d6efd;
    font-size: 0.8rem;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    transition: background-color 0.2s;
    
    &:hover {
      background-color: #e9ecef;
    }
    
    &:active {
      background-color: #dee2e6;
    }
  }
`;

interface RefactoredVentasPorMesProps {
  onBack?: () => void;
}

export const RefactoredVentasPorMes: React.FC<RefactoredVentasPorMesProps> = ({ onBack }) => {
  return (
    <Container>
      <Header>
        <div className="title">Ventas del mes</div>
        {onBack && (
          <button className="back-button" onClick={onBack}>
            ← Atrás
          </button>
        )}
      </Header>
      <ResumenDeVentasPorMes />
    </Container>
  );
};

export default RefactoredVentasPorMes;